angular.module('app').factory('TestNotesService', function (HttpHelper) {
    var fac = {
        unreadTestNotesCount: unreadTestNotesCount,
        unreadTestNotes: unreadTestNotes,
        addNoteNotification: addNoteNotification,
        resolve: resolve,
        selectedItems: selectedItems
    };
    function unreadTestNotesCount() {
        return HttpHelper.get('api/TestNotes/UnreadTestNotesCount');
    }
    function unreadTestNotes() {
        return HttpHelper.get('api/TestNotes/UnreadTestNotes');
    }
    function addNoteNotification(noteId, userId, note) {
        var data = { NoteId: noteId, UserId: userId, Note: note };
        return HttpHelper.post('api/TestNotes/addNoteNotification', data);
    }
    // TODO: Rename to resolve
    function resolve(sysMsgId) {
        return HttpHelper.post('api/TestNotes/Resolve?SysMsgId=' + sysMsgId);
    }
    // TODO: Should be called testDetails
    function selectedItems(traceId) {
        return HttpHelper.get('api/TestNotes/TestDetails?TraceId=' + traceId);
    }
    return fac;
});